import styled from 'styled-components'

export const Styles = styled.div`
	.modal-container{
		
	}
    .logoREVCON{
        width: 86px;
        height: 59px;
    }
	.close-btn{
        color: white
    }

    .main-btn{
        border-radius: 15px;
        background: #00AEFF 0% 0% no-repeat padding-box;
		width: 50%;
		text-align: center
        font: normal normal bold 11px/19px Montserrat;
        letter-spacing: 0px;
        border: none;
    }

    .title{
        text-align: center;
        width: 100%;
        font: normal normal 300 18px/20px Montserrat;
        letter-spacing: 0px;
        color: #FFFFFF;
    }

    .bold-title{
        text-align: center;
        width: 100%;
        font: normal normal bold 18px/20px Montserrat;
        letter-spacing: 0px;
        color: #FFFFFF;
    }
`
